import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { IonRouterOutlet, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { PlatformProvider, PlatformName } from './platform.provider';

@Injectable()
export class DeviceActionsService {
	private backButtonSubscription: Subscription;

	public constructor(
		private platform: Platform,
		private locationStrategy: LocationStrategy,
		private platformProvider: PlatformProvider
	) {}

	public deactivateBackButton(routerOutlet: IonRouterOutlet): void {
		if (this.platform.is('android')) {
			if (this.backButtonSubscription) {
				this.backButtonSubscription.unsubscribe();
			}
			this.backButtonSubscription = this.platform.backButton.subscribeWithPriority(
				9999,
				/* eslint-disable @typescript-eslint/no-unused-vars */
				(_) => {}
			);
		}

		routerOutlet.swipeGesture = false;

		if (this.platformProvider.getPlatform() === PlatformName.WEB) {
			history.pushState(null, null, location.href);
			this.locationStrategy.onPopState(() => {
				window.history.pushState(null, null, location.href);
			});
		}
	}

	public reactivateBackButton(routerOutlet: IonRouterOutlet): void {
		if (this.platform.is('android') && this.backButtonSubscription) {
			this.backButtonSubscription.unsubscribe();
		}

		routerOutlet.swipeGesture = true;
	}
}
